var _defs, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconLine = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_line",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .line-class-a {\n        fill: none !important;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_521",
    className: "line-class-a",
    "data-name": "Rectangle 521",
    width: 32,
    height: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_866",
    "data-name": "Path 866",
    d: "M93,1683.212,74.208,1702,73,1700.788,91.792,1682Z",
    transform: "translate(-67 -1676)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconLine);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_line.9d4043b521524bf46acba903066c33a3.svg";